import { render } from "./BackToTopButton.vue?vue&type=template&id=15e00df4"
import script from "./BackToTopButton.vue?vue&type=script&lang=js"
export * from "./BackToTopButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__